// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---

interface ProfilePictureState {
  profilePicture: string;
}

const initialState: ProfilePictureState = {
  profilePicture: null
};

const profilePictureSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'profilePicture',
  initialState,
  reducers: {
    updateProfilePicture(state, action: PayloadAction<string>) {
      state.profilePicture = action.payload;
    }
  }
});

export const {updateProfilePicture} = profilePictureSlice.actions;

export default profilePictureSlice.reducer;
